module.exports = __webpack_public_path__ + "media/world.970a3386.mp4";